import { State } from './reducer';

export interface AppState {
  errors: State;
  [anyProp: string]: any;
}

export function hasError(state: AppState) {
  return !!state.errors;
}
